import { EErrorType, ICadastralFieldError, IErrors } from '../../../types/reducers/rosreestrData';

export const getError = (errors: IErrors, value?: string): ICadastralFieldError | undefined => {
  const { validationError, notFoundError, requiredError } = errors;

  if (value && validationError.value === value) {
    return {
      type: EErrorType.ValidationError,
      text: validationError.message,
    };
  }

  if (notFoundError && notFoundError.value === value) {
    return {
      type: EErrorType.NotFoundError,
      text: notFoundError.message,
    };
  }

  if (requiredError.value) {
    return {
      type: EErrorType.RequiredError,
      text: requiredError.message,
    };
  }

  return undefined;
};
